import actionCreatorFactory from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
//const authentication = require('react-azure-adb2c').default;
//import { Dispatch } from 'redux';


import { call, put, takeEvery, select } from 'redux-saga/effects';
// import * as RentContractMoniesApi from '../Api/RentContractMoniesApi.ts_';
// import * as RentContractAccountingApi from '../Api/RentContractAccountingApi.ts_';
import * as rent_contracts_api from '../Api/rent_contracts_api';
// import * as UsersApi from './Api/UsersApi';
// import * as RentAgentsApi from './Api/RentAgentsApi';
import * as Kyousai from '../../Kyousai/Saga/Kyousai';
///types

var moment = require("moment-timezone");
//export interface HogeState {
//    responselist: string[];
//    responseedit: number;
//}
export interface RentContractMoniesState {
    // rent_contract_monies:any;
    rent_contracts: any;
    search_name: string;
    search_contract_date_start: any;
    search_contract_date_end: any;
    search_tatemono_name: any;
    bind_disabled: boolean;
}
const initialState: RentContractMoniesState = {

    // rent_contract_monies: [],
    rent_contracts: [],
    search_name: "",
    search_contract_date_start: moment().tz("Asia/Tokyo").format('YYYY-MM-DD'),
    search_contract_date_end: null,
    search_tatemono_name: "",
    bind_disabled: false,
    // users: [],
    // rentAgents: [],
    // rentMReasons: [],



}



///action 
const actionCreator = actionCreatorFactory();

// export const get_rent_contract_monies = actionCreator<{rent_contract_id:number}>('GET_RENT_CONTRACT_MONIES');
// export const get_rent_contract_monies_success = actionCreator("GET_RENT_CONTRACT_MONIES_SUCCESS");
// export const get_rent_contract_monies_failure = actionCreator("GET_RENT_CONTRACT_MONIES_FAILURE");

// export const get_rent_contract_accounting = actionCreator("GET_RENT_CONTRACT_ACCOUNTING");


export const get_rent_contracts = actionCreator<any>('GET_RENT_CONTRACTS');
export const change_rent_contracts = actionCreator("CHANGE_RENT_CONTRACTS");

export const change_search_name = actionCreator<string>("CHANGE_SEARCH_NAME");
export const change_search_contract_date_start = actionCreator<string>("CHANGE_SEARCH_CONTRACT_DATE_START");
export const change_search_contract_date_end = actionCreator<string>("CHANGE_SEARCH_CONTRACT_DATE_END");


export const bind_kyousai_contract = actionCreator('BIND_KYOUSAI_CONTRACT');
export const bind_kyousai_contract_cancel = actionCreator<boolean>("BIND_KYOUSAI_CONTRACT_CANCEL");

export const change_search_tatemono_name = actionCreator<string>("CHANGE_SEARCH_TATEMONO_NAME");

export const change_bind_disabled = actionCreator<boolean>("CHANGE_BIND_DISABLED");



// export const get_banks_failure = actionCreator("GET_BANKS_FAILURE");

// export const getUsers = actionCreator('USERS_REQUEST');
// export const getUsersSuccess = actionCreator("USERS_SUCCESS");
// export const getUsersFailure = actionCreator("USERS_FAILURE");

// export const getRentAgents = actionCreator('RENT_AGENTS_REQUEST');
// export const getRentAgentsSuccess = actionCreator("RENT_AGENTS_SUCCESS");
// export const getRentAgentsFailure = actionCreator("RENT_AGENTS_FAILURE");


// export const getRentMReasons = actionCreator('RENT_M_REASONS_REQUEST');
// export const getRentMReasonsSuccess = actionCreator("RENT_M_REASONS_SUCCESS");
// export const getRentMReasonsFailure = actionCreator("RENT_M_REASONS_FAILURE");


export const contractsearchReducer = reducerWithInitialState(initialState)
    .case(change_rent_contracts, (state, payload) => ({ ...state, rent_contracts: payload }))
    .case(change_search_name, (state, payload) => ({ ...state, search_name: payload }))
    .case(change_search_contract_date_start, (state, payload) => ({ ...state, search_contract_date_start: payload }))
    .case(change_search_contract_date_end, (state, payload) => ({ ...state, search_contract_date_end: payload }))
    .case(change_search_tatemono_name, (state, payload) => ({ ...state, search_tatemono_name: payload }))
    .case(change_bind_disabled, (state, payload) => ({ ...state, bind_disabled: payload }))


//.case(getRentMMedeasFailure, (state, payload) => ({ ...state, rentMMedeas: payload }))
// .case(getUsersSuccess, (state, payload) => ({ ...state, users: payload }))
// .case(getUsersFailure, (state, payload) => ({ ...state, users: payload }))
// .case(getRentAgentsSuccess, (state, payload) => ({ ...state, rentAgents: payload }))
// .case(getRentAgentsFailure, (state, payload) => ({ ...state, rentAgents: payload }))
// .case(getRentMReasonsSuccess, (state, payload) => ({ ...state, rentMReasons: payload }))
// .case(getRentMReasonsFailure, (state, payload) => ({ ...state, rentMReasons: payload }));







// 「LOGIN_REQUEST」アクションが呼ばれるのを待つ呼ばれたhandleRequestを実行
export const contractsearchSaga = [
    //     takeEvery('GET_RENT_CONTRACT_MONIES', handleRequestMoney),
    // takeEvery('GET_RENT_CONTRACT_ACCOUNTING', handle_get_rent_contract_accounting),
    takeEvery('GET_RENT_CONTRACTS', handle_get_rent_contracts),

    takeEvery('BIND_KYOUSAI_CONTRACT', handle_bind_kyousai_contract),

    takeEvery('BIND_KYOUSAI_CONTRACT_CANCEL', handle_bind_kyousai_contract_cancel),

    // takeEvery('USERS_REQUEST', handleUsersRequest),
    // takeEvery('RENT_AGENTS_REQUEST', handleRentAgentsRequest),
    // takeEvery('RENT_M_REASONS_REQUEST', handleRentMReasonsRequest),
];
// export default masterSaga;



function* handle_bind_kyousai_contract(action: any): any {

    const state = yield select();

    yield put(change_bind_disabled(true));
    // let search_name = state.contractsearchReducer.search_name
    let search_id = state.kyousaiReducer.search_id
    const { payload, error } = yield call(rent_contracts_api.bind_kyousai, { rent_contract_id: action.payload, kyousai_id: search_id });

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // 成功時アクション呼び出し
        console.log(payload)
        let kyousais = state.kyousaiReducer.kyousais

        // alert()
        // console.log(kyousais.filter((a: any) => a.id === kyousais[0].id))

        // let array = kyousais.filter((a: any) => a.id !== kyousais[0].id)

        // let array = kyousais.filter((a: any) => a.id !== kyousais[0].id)
        //プロパティ変更
        kyousais.map(function (x: any) {
            if (x.id === payload[0].id) {
                x.processing = payload[0].processing
                x.rent_contract_id = payload[0].rent_contract_id
                x.rent_contract_tatemono_name = payload[0].rent_contract_tatemono_name
                x.rent_contract_name1 = payload[0].rent_contract_name1
                x.rent_contract_room_name = payload[0].rent_contract_room_name
                x.rent_contract_rent_m_etc_id = payload[0].rent_contract_rent_m_etc_id
                x.contract_amount = payload[0].contract_amount
            }
            return x;
        })


        // kyousais.filter((a: any) => a.id === kyousais[0].id)[0].rent_contract_id = payload[0].rent_contract_id
        // kyousais.filter((a: any) => a.id === kyousais[0].id)[0].rent_contract_tatemono_name = payload[0].rent_contract_tatemono_name
        // kyousais.filter((a: any) => a.id === kyousais[0].id)[0].rent_contract_name1 = payload[0].rent_contract_name1
        // console.log(kyousais)
        // array.push(koushin)
        // console.log(array)
        // alert()

        yield put(Kyousai.change_grid_update(true));
        yield put(Kyousai.change_kyousais(kyousais));
        // yield put(get_rent_contracts(payload));
        yield put(Kyousai.change_search_modal(false));
        yield put(change_bind_disabled(false));



    } else {
        yield put(change_bind_disabled(false));
        alert(error);
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}



function* handle_bind_kyousai_contract_cancel(action: any): any {

    const state = yield select();

    yield put(change_bind_disabled(true));
    // let search_name = state.contractsearchReducer.search_name
    let search_id = state.kyousaiReducer.search_id
    const { payload, error } = yield call(rent_contracts_api.bind_kyousai_cancel, { kyousai_id: search_id });

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // 成功時アクション呼び出し
        console.log(payload)
        let kyousais = state.kyousaiReducer.kyousais

        // alert()
        // console.log(kyousais.filter((a: any) => a.id === kyousais[0].id))

        // let array = kyousais.filter((a: any) => a.id !== kyousais[0].id)

        // let array = kyousais.filter((a: any) => a.id !== kyousais[0].id)
        //プロパティ変更
        kyousais.map(function (x: any) {
            if (x.id === payload[0].id) {
                x.processing = payload[0].processing
                x.rent_contract_id = payload[0].rent_contract_id
                x.rent_contract_tatemono_name = payload[0].rent_contract_tatemono_name
                x.rent_contract_name1 = payload[0].rent_contract_name1
                x.rent_contract_room_name = payload[0].rent_contract_room_name
                x.rent_contract_rent_m_etc_id = payload[0].rent_contract_rent_m_etc_id
                x.contract_amount = payload[0].contract_amount
            }
            return x;
        })


        // kyousais.filter((a: any) => a.id === kyousais[0].id)[0].rent_contract_id = payload[0].rent_contract_id
        // kyousais.filter((a: any) => a.id === kyousais[0].id)[0].rent_contract_tatemono_name = payload[0].rent_contract_tatemono_name
        // kyousais.filter((a: any) => a.id === kyousais[0].id)[0].rent_contract_name1 = payload[0].rent_contract_name1
        // console.log(kyousais)
        // array.push(koushin)
        // console.log(array)
        // alert()

        yield put(Kyousai.change_grid_update(true));
        yield put(Kyousai.change_kyousais(kyousais));
        // yield put(get_rent_contracts(payload));
        yield put(Kyousai.change_search_modal(false));
        yield put(change_bind_disabled(false));



    } else {
        yield put(change_bind_disabled(false));
        alert(error);
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}


// function* handle_get_rent_contract_accounting(action:any) {

//     const { payload, error }= yield call(RentContractAccountingApi.list, action.payload);

//        // サーバーからのレスポンスデータによる分岐処理
//        if (payload && !error) {
//            // 成功時アクション呼び出し
//        console.log(payload)
//        const a = document.createElement('a');
// // ダウンロードされるファイル名
// a.download = "会計.csv";
// a.href = URL.createObjectURL(payload);
// // ダウンロード開始
// a.click();
//     //    yield put(get_rent_contract_monies_success(payload));

//        } else {
//        //    // 失敗時アクション呼び出し
//        //    yield put(loginFailure(payload));
//        }
//    }



function* handle_get_rent_contracts(action: any): any {
    console.log(action.payload)

    const state = yield select();
    let search_name = state.contractsearchReducer.search_name
    let search_contract_date_start = state.contractsearchReducer.search_contract_date_start
    let search_contract_date_end = state.contractsearchReducer.search_contract_date_end
    let search_tatemono_name = state.contractsearchReducer.search_tatemono_name

    const { payload, error } = yield call(rent_contracts_api.list, { name: search_name, search_contract_date_start: search_contract_date_start, search_contract_date_end: search_contract_date_end, search_tatemono_name: search_tatemono_name });

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload)

        yield put(change_rent_contracts(payload));
        //    yield put(get_rent_contract_monies_success(payload));

    } else {

        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}







// function* handleRentAgentsRequest(action: any) {

//     let { payload } = action;
//     payload = yield call(RentAgentsApi.RentAgentsList, payload);

//     // サーバーからのレスポンスデータによる分岐処理
//     //if (ログイン成功か失敗かの条件) {
//     // 成功時アクション呼び出し
//     console.log(payload)

//     yield put(getRentAgentsSuccess(payload));
//     //} else {
//     //    // 失敗時アクション呼び出し
//     //    yield put(loginFailure(payload));
//     //}
// }

// function* handleRentMReasonsRequest(action: any) {

//     let { payload } = action;
//     payload = yield call(RentMReasonsApi.RentMReasonsList, payload);

//     // サーバーからのレスポンスデータによる分岐処理
//     //if (ログイン成功か失敗かの条件) {
//     // 成功時アクション呼び出し
//     console.log(payload)

//     yield put(getRentMReasonsSuccess(payload));
//     //} else {
//     //    // 失敗時アクション呼び出し
//     //    yield put(loginFailure(payload));
//     //}
// }